import React, { useState, useEffect } from "react";
import {
  FaMoneyBillAlt,
  FaWarehouse,
  FaUserShield,
  FaRegBuilding,
} from "react-icons/fa";
import img1 from "../../../assets/img/Industries/banking&finance/2147669958.jpg";
import img2 from "../../../assets/img/Industries/banking&finance/2148793796.jpg";
import img3 from "../../../assets/img/Industries/banking&finance/124767.jpg";
import img4 from "../../../assets/img/Industries/banking&finance/3078.jpg";

const FinanceCard = ({ title, description, icon, imageUrl }) => (
  <div className="bg-white rounded-2xl shadow-xl w-full overflow-hidden transition-all duration-300 hover:shadow-2xl hover:scale-105 mx-auto">
    <div className="h-48 overflow-hidden">
      <img src={imageUrl} alt={title} className="w-full h-full object-cover" />
    </div>
    <div className="p-6">
      <div className="flex items-center mb-4">
        {/* <div className="text-3xl text-blue-600 mr-3">{icon}</div> */}
        <h3 className="text-xl font-bold text-gray-800 min-h-[40px]">{title}</h3>
      </div>
      <p className="text-gray-600">{description}</p>
    </div>
  </div>
);

const FinanceSection = () => {
  const financeAreas = [
    {
      title: "Retail Banking",
      description:
        "Enhance customer engagement with personalized services, digital wallets, and AI-powered support.",
      icon: <FaMoneyBillAlt />,
      imageUrl: img1,
    },
    {
      title: "Investment Banking",
      description:
        "Optimize trading platforms, portfolio management, and analytics with advanced technologies.",
      icon: <FaWarehouse />,
      imageUrl: img2,
    },
    {
      title: "Fintech Innovation",
      description:
        "Build innovative financial products and platforms with DeFi, blockchain, and AI-driven solutions.",
      icon: <FaUserShield />,
      imageUrl: img3,
    },
    {
      title: "Insurance",
      description:
        "Modernize underwriting, claims processing, and customer service with AI, analytics, and RPA.",
      icon: <FaRegBuilding />,
      imageUrl: img4,
    },
  ];

  return (
    <div className="min-h-[70vh] bg-gradient-to-br from-blue-50 to-green-50 py-16 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <h1 className="text-4xl font-bold text-center text-gray-800 mb-4">
          Transforming Key Areas of Finance & Banking
        </h1>
        <p className="text-xl text-center text-gray-600 mb-12">
          Leveraging cutting-edge technology to revolutionize financial
          services.
        </p>
        <div className="grid grid-cols-1 w-full md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-4 gap-14">
          {financeAreas.map((area, index) => (
            <FinanceCard key={index} {...area} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default FinanceSection;
